import { EyeClosedIcon, EyeOpenIcon } from '@radix-ui/react-icons';
import { t } from 'i18next';
import { Button } from '../../Button';
import { IconButton } from '../../IconButton';
import { Input } from '../../Input';
import { useChangePasswordFormController } from './useChangePasswordFormController';

export default function ChangePasswordForm() {
  const {
    errors,
    isFetching,
    isCurrentPasswordVisible,
    isNewPasswordVisible,
    isConfirmPasswordVisible,
    register,
    handleSubmit,
    handleToggleCurrentPasswordVisibility,
    handleToggleNewPasswordVisibility,
    handleToggleConfirmPasswordVisibility,
  } = useChangePasswordFormController();

  return (
    <form
      className="my-4 flex w-full flex-col items-center gap-4"
      onSubmit={handleSubmit}
    >
      <Input
        type={isCurrentPasswordVisible ? 'text' : 'password'}
        placeholder={t('settings.changePassword.fields.currentPassword')}
        {...register('currentPassword')}
        error={errors.currentPassword?.message}
        autoComplete="current-password"
        disabled={isFetching}
      >
        <IconButton
          className="absolute top-0 right-1 size-10 rounded-md"
          onClick={handleToggleCurrentPasswordVisibility}
          disabled={isFetching}
          aria-label={t(
            isCurrentPasswordVisible
              ? 'settings.changePassword.passwordVisibility.hideCurrent'
              : 'settings.changePassword.passwordVisibility.showCurrent',
          )}
        >
          {isCurrentPasswordVisible ? <EyeClosedIcon /> : <EyeOpenIcon />}
        </IconButton>
      </Input>

      <Input
        type={isNewPasswordVisible ? 'text' : 'password'}
        placeholder={t('settings.changePassword.fields.newPassword')}
        {...register('newPassword')}
        error={errors.newPassword?.message}
        autoComplete="new-password"
        disabled={isFetching}
      >
        <IconButton
          className="absolute top-0 right-1 size-10 rounded-md"
          onClick={handleToggleNewPasswordVisibility}
          disabled={isFetching}
          aria-label={t(
            isNewPasswordVisible
              ? 'settings.changePassword.passwordVisibility.hideNew'
              : 'settings.changePassword.passwordVisibility.showNew',
          )}
        >
          {isNewPasswordVisible ? <EyeClosedIcon /> : <EyeOpenIcon />}
        </IconButton>
      </Input>

      <Input
        type={isConfirmPasswordVisible ? 'text' : 'password'}
        placeholder={t('settings.changePassword.fields.confirmPassword')}
        {...register('confirmPassword')}
        error={errors.confirmPassword?.message}
        autoComplete="new-password"
        disabled={isFetching}
      >
        <IconButton
          className="absolute top-0 right-1 size-10 rounded-md"
          onClick={handleToggleConfirmPasswordVisibility}
          disabled={isFetching}
          aria-label={t(
            isConfirmPasswordVisible
              ? 'settings.changePassword.passwordVisibility.hideConfirmation'
              : 'settings.changePassword.passwordVisibility.showConfirmation',
          )}
        >
          {isConfirmPasswordVisible ? <EyeClosedIcon /> : <EyeOpenIcon />}
        </IconButton>
      </Input>

      <section className="mt-4 flex w-full">
        <Button
          labelPath="settings.changePassword.submit"
          type="submit"
          disabled={isFetching}
          isLoading={isFetching}
        />
      </section>
    </form>
  );
}
